import { render, staticRenderFns } from "./flightStautsData.vue?vue&type=template&id=aac5a4b0&"
import script from "./flightStautsData.vue?vue&type=script&lang=js&"
export * from "./flightStautsData.vue?vue&type=script&lang=js&"
import style0 from "./flightStautsData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports